// The Bay's page: the GTFS page (@tol/gtfs/page) with the Bay's lines.

import { createGtfsPage } from '@tol/gtfs/page';
import { BAY_PAGE } from './page.ts';

await createGtfsPage(BAY_PAGE);
